import { render, staticRenderFns } from "./addAndEditVideo.vue?vue&type=template&id=1162061a&scoped=true"
import script from "./addAndEditVideo.vue?vue&type=script&lang=js"
export * from "./addAndEditVideo.vue?vue&type=script&lang=js"
import style0 from "./addAndEditVideo.vue?vue&type=style&index=0&id=1162061a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162061a",
  null
  
)

export default component.exports